import { Node, NodeProps } from 'reactflow';
import { TopicNodeData, TypeTopicNode } from '../topic-node/topic-node.model';

export const hierarchyRootNodeId = 'hierarchy-topic-root';
export const topicRoodNodeId = 'topic-root';

export type HierarchyNodeData = {
  topicNode: TypeTopicNode;
  state: {
    isRecommended?: boolean;
    isEditing?: boolean;
  }
};

export type TypeHierarchyNode = Node<HierarchyNodeData>;

export type HierarchyNodeProps = NodeProps<HierarchyNodeData>;
